export default __webpack_public_path__ + "static/media/Footer-Ubitech-Logo.819592cc.svg";